import React from "react";
import ServiceCard from "../components/ServiceCard";
import Hero from "../components/Hero";
      

export default function Services({ t, langData }) {
  
  const items = langData.home2.services;
  const items2= langData.home2.services2;
  return (
   // console.log(items2),
    <>
    <section className="">
       <Hero  t={t} className="bg-body-tertiary rounded-0 " />
      <div className="container">
        <h1 className="fw-bold mb-4 text-center mt-5">{t("services")}</h1>
        <div className="row g-4">
          {items.map((s, idx)=>(
            <div className="col-md-6 col-lg-3" key={idx}>
              <ServiceCard {...s} />
            </div>
          ))}
        </div>
      </div>
    </section>

    <div className="container my-5">
  <div className="row g-4">
    {/* العمود الأيمن */}
    <div className="col-md-6 d-flex flex-column gap-4">
      {items2.slice(0, 3).map((item, i) => (
        <div key={i} className="card shadow-sm border-0 h-100">
          <div className="card-body">
            <h5 className="card-title fw-bold mb-3 text-primary">
              <i className="bi bi-check-circle-fill me-2 text-success"></i>
              {item.title}
            </h5>
            <ul className="list-unstyled ps-3 mb-0">
              {item.text.map((point, j) => (
                <li key={j} className="mb-2 d-flex align-items-center">
                  <i className="bi bi-arrow-right-circle me-2 text-secondary"></i>
                  {point}
                </li>
              ))}
            </ul>
          </div>
        </div>
      ))}
    </div>

    {/* العمود الأيسر */}
    <div className="col-md-6 d-flex flex-column gap-4">
      {items2.slice(3, 6).map((item, i) => (
        <div key={i} className="card shadow-sm border-0 h-100">
          <div className="card-body">
            <h5 className="card-title fw-bold mb-3 text-primary">
              <i className="bi bi-check-circle-fill me-2 text-success"></i>
              {item.title}
            </h5>
            <ul className="list-unstyled ps-3 mb-0">
              {item.text.map((point, j) => (
                <li key={j} className="mb-2 d-flex align-items-center">
                  <i className="bi bi-arrow-right-circle me-2 text-secondary"></i>
                  {point}
                </li>
              ))}
            </ul>
          </div>
        </div>
      ))}
    </div>
  </div>
</div>

    </>
  );
}
